export abstract class StorageKeys {
    public static PRINCIPAL = 'principal';
    public static SIGHTNESS_TOKEN = 'sightness-token';
}
